import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PageHeader, Spinner, Pill, statusTone, EmptyState, ProgressBar } from "@/components/common";
import { STUDY_STATUS } from "@/lib/i18n";
import { DeleteStudyButton } from "@/features/admin/DeleteStudyButton";

export default function EvaluationsPage() {
  const [items, setItems] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/admin/studies").then((r) => setItems(r.data)); }, []);
  if (!items) return <Spinner />;
  const groups = [["ACTIVE", "Aktif Değerlendirmeler"], ["DRAFT", "Taslaklar"], ["CLOSED", "Kapanan"]];
  return (
    <div className="fade-up">
      <PageHeader eyebrow="Değerlendirmeler" title="Değerlendirmeler" actions={<Button data-testid="evaluations-new-button" onClick={() => nav("/admin/evaluations/new")} className="btn-press rounded-full"><Plus className="mr-1.5 h-4 w-4" /> Yeni Değerlendirme</Button>} />
      {items.length === 0 && <EmptyState testId="evaluations-empty" title="Henüz değerlendirme yok" description="İlk değerlendirme çalışmanızı oluşturmak için sağ üstteki düğmeyi kullanın." />}
      {groups.map(([status, label]) => {
        const list = items.filter((s) => s.status === status);
        if (!list.length) return null;
        return (
          <section key={status} className="mb-10">
            <h2 className="mb-3 font-heading text-base font-semibold md:text-lg">{label}</h2>
            <div className="space-y-3">
              {list.map((st) => (
                <Link key={st.id} to={`/admin/evaluations/${st.id}${status === "DRAFT" ? "/setup" : ""}`} data-testid={`study-card-${st.id}`} className="plena-card plena-card-hover block px-6 py-5">
                  <div className="flex items-start justify-between gap-4">
                    <div className="min-w-0">
                      <p className="font-heading text-base font-semibold">{st.title}</p>
                      <p className="mt-1 text-sm text-plena-text2">{st.candidate_count} aday · {st.criteria_count} kategori · {st.evaluator_count} değerlendirici</p>
                    </div>
                    <div className="flex items-center gap-2">
                      <Pill tone={statusTone(st.status)}>{STUDY_STATUS[st.status]}</Pill>
                      <span onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                        <DeleteStudyButton study={st} iconOnly onDeleted={() => setItems((xs) => xs.filter((x) => x.id !== st.id))} />
                      </span>
                    </div>
                  </div>
                  {status === "ACTIVE" && (
                    <div className="mt-4 flex items-center gap-4">
                      <div className="flex-1"><ProgressBar value={st.submitted_count} total={st.evaluator_count} tone="bg-plena-success" /></div>
                      <span className="text-xs font-medium text-plena-text2">{st.submitted_count} / {st.evaluator_count} tamamlandı</span>
                    </div>
                  )}
                </Link>
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}
